// extracted by mini-css-extract-plugin
export default {"tableWrap":"StatementsList_tableWrap__beJw1","empty":"StatementsList_empty__4BWbk"};